<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        md="12"
        sm="12"
      >
        <v-data-table-server
          v-model:options="options"
          dense
          :headers="headers"
          :loading="loading"
          :items="items"
          :items-length="totalItems"
          class="elevation-1"
          :items-per-page-options="footerProps.itemsPerPageOptions"
          @update:options="updateTable"
        >
          <template #top>
            <v-card-title>
              <v-toolbar flat>
                <v-toolbar-title>Campaigns</v-toolbar-title>
                <v-spacer />
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  @input="searchTable()"
                />
                <v-spacer />
              </v-toolbar>
            </v-card-title>
          </template>
          <template #item.actions="{ item }">
            <v-btn
              v-if="hasPermission('view ticket::show')"
              x-small
              color="primary"
              class="mr-2"
              :disabled="selectedCampaign && selectedCampaign.id !== item.id"
              @click="selectCampaign(item, (selectedCampaign) ? 'Un-select' : 'Select')"
            >
              <v-icon
                left
                dark
              >
                mdi-ticket
              </v-icon>
              {{ (selectedCampaign) ? 'Un-select' : 'Select' }}
            </v-btn>
          </template>
        </v-data-table-server>
      </v-col>
      <v-col
        v-if="selectedCampaign"
        cols="12"
        md="12"
        sm="12"
      >
        <v-card>
          <v-card-title class="text-uppercase">
            Campaign Customer
          </v-card-title>
          <v-card-text>
            <v-alert
              color="blue-grey"
              dark
              dense
              icon="mdi-alert"
              prominent
            >
              <h3>
                Please do not refresh the page or click on another link until
                this process is complete. Thank you for your patience.
              </h3>

              <h3 class="mt-2">
                Steps
              </h3>
              <ul>
                <li>Find the next customer</li>
                <li>Create zendesk ticket</li>
                <li>Assign the ticket</li>
                <li>Update the data</li>
                <li>Redirect to tbot</li>
              </ul>
            </v-alert>

            <v-btn
              color="primary"
              class="mr-2"
              :disabled="!selectedCampaign"
              :loading="processingNextCustomer"
              @click="processNextCustomer()"
            >
              <v-icon
                left
                dark
              >
                mdi-cog-transfer
              </v-icon>
              Process Next Customer
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { mapActions } from 'vuex';
import dataTableMixin from '@/mixins/dataTableMixin.js';

export default {
  name: 'TicketCampaign',

  mixins: [
    dataTableMixin,
  ],

  data() {
    return {
      headers: [
        { title: 'Name', value: 'name', sortable: false },
        { title: 'Instructions', value: 'instructions', sortable: false },
        { title: 'Actions', value: 'actions', sortable: false },
      ],
      search: '',
      selectedCampaign: null,
      processingNextCustomer: false,
    };
  },

  watch: {
    search() {
      this.selectedCampaign = null;
    },
  },

  methods: {
    ...mapActions('notification', ['setNotification']),
    ...mapActions('ticket', ['setOutboundTicket', 'setActiveTab']),

    processNextCustomer() {
      this.processingNextCustomer = true;

      return this.$axios.post('api/v1/support/outbound-call-campaign/process-next', {
        campaignId: this.selectedCampaign.id,
      })
        .then((res) => {
          this.processingNextCustomer = false;

          if (res.status === 200) {
            this.setOutboundTicket({
              campaign: res.data?.data?.campaign ?? [],
              customer: res.data?.data?.customer ?? [],
            });

            const zdTicketId = res.data?.data?.zdTicketId ?? 0;

            if (zdTicketId) {
              this.setActiveTab(1);
              this.$router.push({ name: 'ticket-show', params: { id: zdTicketId.toString() } });
            } else {
              this.setNotification({
                message: 'Error getting the new ticket id. Please Try again later',
                color: 'red',
              });
            }
          }
        })
        .catch((error) => {
          this.processingNextCustomer = false;
          let errMsg = 'There was an error processing your request';
          console.log(error);
          if (error.response && error.response.status === 404 && error.response.data) {
            errMsg = error.response.data.message;
          }

          if (error.response && error.response.status === 422) {
            console.log(error.response);

            errMsg = error.response.data.message;
            if (error.response.data.errors) {
              Object.values(error.response.data.errors).forEach((val) => {
                errMsg += `\n ${val}`;
              });
            }
          }

          if (error.response && error.response.status === 500) {
            errMsg = error.response.data.message;
          }

          this.loadingModel = false;
          this.setNotification({
            message: errMsg,
            color: 'red',
          });
        });
    },

    selectCampaign(item, type) {
      if (type.toLowerCase() === 'select') {
        this.selectedCampaign = item;
      } else {
        this.selectedCampaign = null;
      }
    },

    updateTable() {
      setTimeout(() => this.sendUpdateTable(), 750);
    },

    sendUpdateTable() {
      if (this.search === '') return null;

      this.loading = true;

      return this.$axios
        .get('api/v1/support/outbound-call-campaign', {
          params: {
            paginate: true,
            search: this.search,
            active: true,
          },
        })
        .then((res) => {
          this.loading = false;
          this.items = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch((error) => {
          this.loading = false;
          this.items = [];
          let errMsg = 'There was an error processing your request';
          if (error.response && error.response.status === 404 && error.response.data) {
            errMsg = error.response.data.message;
          }

          if (error.response && error.response.status === 422) {
            console.log(error.response);

            errMsg = error.response.data.message;
            if (error.response.data.errors) {
              Object.values(error.response.data.errors).forEach((val) => {
                errMsg += `\n ${val}`;
              });
            }
          }

          if (error.response && error.response.status === 500) {
            errMsg = error.response.data.message;
          }

          this.loadingModel = false;
          this.setNotification({
            message: errMsg,
            color: 'red',
          });
        });
    },
  },

};

</script>

<style scoped>

</style>
